ui-cms-newsletter-cta {
  display: block;

  .newsletter {
    p {
      margin-bottom: 0;
      line-height: 1.5;
      margin-top: 0.25rem;
    }

    &__form {
      display: flex;
      flex-direction: column;
      padding-top: 0.75rem;

      ui-button {
        margin-top: 15px;
        height: 48px;
      }

      @include breakpoint($medium) {
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;

        > div {
          width: 100%;
        }

        ui-input {
          flex: 1;
          width: 100%;
        }

        ui-button {
          margin: 0 0 0 8px;
          align-items: center;
        }
      }
    }
  }
}
